export default __webpack_public_path__ + "static/media/logo-us-sephora.dbdcad41.svg";